import { service } from 'services';
import { hotGetAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

export default {
  getAll: async () => hotGetAction({
    action: ACTIONS_TYPES.CONTRACT.GET_ALL,
    apiResult: service.contract.getAll(),
    retrieveByFunction: (response) => {
      const { items = [] } = response || {};
      return items;
    },
  }),
};
